
const digest = 'd04bd5938a877ebbff1a40d1a67e0a8c8981400968a9a7953a4facb77c701259';
const classes = {"wrapper":"_wrapper_1tye7_1","list":"_list_1tye7_9","infoWrapper":"_infoWrapper_1tye7_37"};
const css = `._wrapper_1tye7_1 {
  font-family: "Rubik", sans-serif;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
}
._wrapper_1tye7_1 ._list_1tye7_9 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_1tye7_1 ._list_1tye7_9::-webkit-scrollbar {
  display: block;
}
._wrapper_1tye7_1 ._list_1tye7_9::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_1tye7_1 ._list_1tye7_9::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1tye7_1 ._list_1tye7_9::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1tye7_1 ._list_1tye7_9::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1tye7_1 ._infoWrapper_1tye7_37 {
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  